<template>
  <div class="ccui-error-305-main">
    <div class="ccui-error-305__pic">
      <img
        src="@/basa/assets/305_images/305.png"
        alt="305"
        width="180px"
        height="180px"
        style="margin:0 auto;"
      />
    </div>
    <div class="ccui-error-305-detail">
      <div class="ccui-error-305-detail-text">
        很抱歉，您需经单位应用管理员启用应用并授权才能使用本应用
      </div>
      <div class="ccui-error-305-detail-button">
        <el-button type="primary" @click="goBack">返回</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "error305",
  data() {
    return {};
  },
  methods: {
    goBack() {
      window.location.href = this.$addUrlPerFix(process.env.VUE_APP_BASE_URL);
    }
  }
};
</script>
<style scoped lang="scss">
/deep/.ccui-error-305__pic {
  float: none;
  text-align: center;
  margin-top: 0;
}
/deep/.ccui-error-305-detail {
  margin: 0;
  text-align: center;
  width: 100%;
  .ccui-error-305-detail-text {
    width: 100%;
    font-size: 22px;
    color: #4a4a4a;
    margin-top: 20px;
    font-weight: normal;
    .ccui-error-305-detail-button {
      margin-top: 20px;
    }
  }
}
/deep/.ccui-error-305-detail-button .el-button {
  width: 180px !important;
  height: 50px !important;
  border: 1px solid #0089ef;
  background: #fff !important;
  color: #0089ef !important;
  span {
    font-size: 22px !important;
  }
}
</style>
